import { prefixObjectValues } from '../../../utils';
const form = {
  form: 'form',
  emailAddressInput: 'email-input',
  isPrimaryToggle: 'primary-toggle',
  submitBtn: 'submit-btn',
};

export default prefixObjectValues(form, 'profile-email-form');
